module.exports = __webpack_public_path__ + "img/donate.1af4ce88.svg";